// extracted by mini-css-extract-plugin
export default {"timerContainer":"CountdownTimer_timerContainer__+WDxB","timerText":"CountdownTimer_timerText__8FEI+"};